// extracted by mini-css-extract-plugin
export default {"centeredButton":"centered-button-module--centered-button--2ad5c","noMargin":"centered-button-module--no-margin--e27e5"};